import { fieldEntryHasPresentableValue } from '@/common/utils/changedDataFieldMerge'

/** Не вызывать empty() если в store или live input уже есть значение фильтра. */
export function shouldSkipEmptyStateForElement(
  merged: Record<string, unknown> | null | undefined,
  elementName: string,
  liveFieldEntry?: unknown,
): boolean {
  const name = String(elementName ?? '').trim()
  if (!name) return false
  const fields = merged ?? {}
  const listboxKey = `${name}__listbox`
  const itemsKey = `${name}__items`
  return (
    fieldEntryHasPresentableValue(fields[name]) ||
    fieldEntryHasPresentableValue(fields[listboxKey]) ||
    fieldEntryHasPresentableValue(fields[itemsKey]) ||
    fieldEntryHasPresentableValue(liveFieldEntry)
  )
}
